import ModalContentSection from './ModalContentSection'

export default function ModalContainer(props) {
    return (
        <div className='modal_container'>
            {props.content && props.content.map(section => <ModalContentSection section={section} />)}
        </div>
    );
}
